import React, { useState } from 'react';
import {
  Row,
  Col,
  Card,
  Form,
  Button,
  OverlayTrigger,
  Tooltip,
  DropdownButton,
  Dropdown,
  Spinner,
} from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { DebounceInput } from 'react-debounce-input';
import Pagination from 'react-js-pagination';
import { useTranslation, Trans } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import flatten from 'helpers/flatten';
import { parseDateBR, curday } from 'helpers/date';
import ActionStatus from 'enums/ActionStatus';
import './style.css';
import Select from 'react-select';
import Can from 'components/Can';
import DatePicker, { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import { formatDate } from 'helpers/date';
import ReactDOMServer from 'react-dom/server'
import { api } from 'services';

registerLocale('pt_BR', ptBR);

const ListingActions = ({
  data,
  filters,
  stateFilters,
  handleFilterChange,
  location,
  isAtacchingFiles,
  attachingFile,
}) => {
  const { t } = useTranslation();

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isExporting, setIsExporting] = useState(false)

  const handlePageChange = (page) => handleFilterChange({ page });

  function changeDateFilter(date, key) {
    const newDate = !date ? null : formatDate(date);
    handleFilterChange({ [key]: newDate });
  }

  const statusName = (status_id) => {
    switch (status_id) {
      case ActionStatus.Draft:
        return 'draft';
      case ActionStatus.OnApproval:
        return 'on_approval';
      case ActionStatus.Disapproved:
        return 'disapproved';
      case ActionStatus.AwaitingArts:
        return 'awaiting_arts';
      case ActionStatus.AwaitingComprovations:
        return 'awaiting_comprovations';
      case ActionStatus.ComprovationsApproval:
        return 'comprovations_approval';
      case ActionStatus.DisapprovedComprovations:
        return 'disapproved_comprovations';
      case ActionStatus.AwaitingReceipt:
        return 'awaiting_receipt';
      case ActionStatus.Finished:
        return 'finished';
      case ActionStatus.Cancelled:
        return 'canceled';
      case ActionStatus.OnExecution:
        return 'on_execution';
      case ActionStatus.ControllingApproval:
        return 'controlling_approval';
      case ActionStatus.WaitingCancellationApproval:
        return 'waiting_cancellation_approval';
      case ActionStatus.BriefingRefused:
        return 'briefing_refused'; 
    }
  };

  const isLate = (end_date) => {
    const date = curday('-');
    return date > end_date ? (
      <OverlayTrigger
        key="top"
        placement="top"
        overlay={<Tooltip id={`tooltip-top`}>{t('label:overdue')}</Tooltip>}
      >
        <i
          style={{ color: 'orange' }}
          className="fas fa-exclamation-triangle"
        />
      </OverlayTrigger>
    ) : (
      <OverlayTrigger
        key="top"
        placement="top"
        overlay={<Tooltip id={`tooltip-top`}>{t('label:in day')}</Tooltip>}
      >
        <i style={{ color: 'green' }} className="fas fa-check-circle" />
      </OverlayTrigger>
    );
  };

  const sameId = (statusId) => {
    let teste = data.data.map((action) => {return action.status_id});
    let xx = false;
    teste.map((value) => {
      if (value !== statusId) {
        return (xx = true);
      }
    });
    return xx;
  };

  const pendingApproval = (dt) => {
    let icon = '--';
    if (dt.comprovations.length !== 0) {
      dt.comprovations.map((comprovation) => {
        if (comprovation.status_id === 10) {
          icon = (
            <OverlayTrigger
              key="top"
              placement="top"
              overlay={
                <Tooltip id={`tooltip-top`}>
                  {t('label:awaiting approval')}
                </Tooltip>
              }
            >
              <i
                style={{ color: '#D71925' }}
                className="fas fa-exclamation-circle"
              />
            </OverlayTrigger>
          );
        }
      });
    }
    return icon;
  };

  const totalFunds = (id) => {
    let countFund = 0;
    let currency = 1;
    data.data.map((action) => {
      if (
        action.id === id ||
        (action.extra_materials !== null && action.id === id)
      ) {
        countFund += action.total_value// + action.expire_value;
        currency = action.currency;
      }
    });
    countFund = parseFloat(countFund);
    return {'value':countFund, 'currency':currency};
  };

  const actionsData = [];

  const renderValue = (value, title) => {
    return (<>
    <div className="mobile-hidden-table-head">{title}: </div>
    {value}
    </>)
  }

  const renderActionBtn = (value) => {
    return (<>
    <div className='mobile-transform-table-card-btn'>
    {value}
    </div>
    </>)
  }

  const limitString = (string, limit = 10) => {
    if (string.length > 10)
      return string.substring(0, limit)+"..."
    
    return string
  }

  function getActions() {
    data.data.map((dt, k) => {
      const data = flatten(dt);
      actionsData.push({
        // iconIsLate: sameId(data.status_id)
        //   ? t(`statuses:${statusName(dt.status_id)}`)
        //   : data.status_id === 21
        //   ? isLate(data.end_date)
        //   : pendingApproval(dt),
        iconIsLate: t(`statuses:${statusName(dt.status_action)}`),
        id: dt.id,
        planId: dt.marketing_plan_id
          ? [
              dt.marketing_plan_id,
              <Link
                variant="light"
                style={{ fontSize: '12px', color: '#212529' }}
                className="ml-2"
                target="_blank"
                to={`/marketing-plans/edit/${dt.marketing_plan_id}`}
              >
                <i className="fas fa-external-link-alt" />
              </Link>,
            ]
          : '--',
        name: (
          <span data-toggle="tooltip" data-placement="top" title={dt.action_name}>{limitString(dt.action_name, 5)}</span>
        ),
        vendor: dt.company_alias,
        initial: dt.start_date,
        final: dt.end_date,
        payment: dt.payment_date,
        value: totalFunds(dt.id),
        analyst: dt.user_name,
        vendor_id: dt.vendor_id,
        task_name: (
          <span data-toggle="tooltip" data-placement="top" title={dt.task_name}>{dt.task_name ? limitString(dt.task_name, 5) : "..."}</span>
        ),
        actions: (
          <div>
            <Link
              to={{
                pathname: `/actions/edit/${dt.id}`,
                search: location.search,
              }}
            >
              <Can do="editAction" on="App">
                <Button
                  size="sm"
                  key={k}
                  variant="light"
                  alt={t('title:edit')}
                  title={t('title:edit')}
                >
                  <i className="fas fa-pen"></i>
                </Button>
              </Can>
            </Link>
            {isAtacchingFiles && (
              <Button
                className="ml-1"
                size="sm"
                key={k}
                variant="light"
                alt={t('label:nf link')}
                title={t('label:nf link')}
                onClick={(state) =>
                  attachingFile({ ...state, status: true, id: dt.id })
                }
              >
                <i className="fas fa-link"></i>
              </Button>
            )}
          </div>
        ),
        isCreativeEditable: dt.quantity_task_items>0,
        hasComprovations: dt.quantity_comprovations>0,
      });
    });
  }

  getActions();

  const getCurrency = (currency) => {
    switch (currency) {
      case 1:
        return 'BRL';
      case 2:
        return 'USD';
      case 3: 
        return 'EUR';
      default:
        return 'BRL';
    }
  }

  const columns = [
    {
      dataField: 'iconIsLate',
      text: 'Status',
      headerStyle: {
        width: '10%',
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      formatter: (cell) => renderValue(cell,'Status')
    },
    {
      dataField: 'id',
      text: ['#', <i className="fas fa-sort float-right" />],
      sort: true,
      headerStyle: {
        width: '5%',
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      formatter: (cell) => renderValue(cell,'#')
    },
    {
      dataField: 'planId',
      text: ['ID do Plano', <i className="fas fa-sort float-right" />],
      sort: true,
      headerStyle: {
        width: '5%',
        text: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      formatter: (cell) => renderValue(cell,'ID do Plano')
    },
    {
      dataField: 'name',
      text: ['Nome', <i className="fas fa-sort float-right" />],
      sort: true,
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      formatter: (cell) => renderValue(cell,'Nome')
    },
    {
      dataField: 'vendor',
      text: [t('label:company'), <i className="fas fa-sort float-right" />],
      sort: true,
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      formatter: (cell) => renderValue(cell,t('label:company'))
    },
    
    {
      dataField: 'task_name',
      text: ['Tipo', <i className="fas fa-sort float-right" />],
      sort: true,
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      formatter: (cell) => renderValue(cell,'Tipo')
    },
    {
      dataField: 'initial',
      text: ['Data Inicial', <i className="fas fa-sort float-right" />],
      sort: true,
      formatter: (cell) => renderValue(cell ? parseDateBR(cell) : '--','Data Inicial'),
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
        width: '10%',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
    },
    {
      dataField: 'final',
      text: ['Data Final', <i className="fas fa-sort float-right" />],
      sort: true,
      formatter: (cell) => renderValue(cell ? parseDateBR(cell) : '--','Data Final'),
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
        width: '10%',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
    },
    {
      dataField: 'payment_date',
      text: ['Data de Pagamento', <i className="fas fa-sort float-right" />],
      sort: true,
      formatter: (cell) => renderValue(cell ? parseDateBR(cell) : '--','Data de Pagamento'),
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
        width: '10%',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
    },
    {
      dataField: 'vendor_id',
      text: 'ID fabricante',
      sort: true,
      formatter: (cell) => renderValue(cell?cell:'---','ID fabricante'),
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
        width: '10%',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
    },
    {
      dataField: 'value',
      text: ['Valor', <i className="fas fa-sort float-right" />],
      sort: true,
      // formatter: (cell) =>
      //   cell.value.toLocaleString('pt-BR', { style: 'currency', currency: getCurrency(cell.currency) }),
      formatter: (cell) => renderValue(
        cell.value.toLocaleString('pt-BR', { style: 'currency', currency: getCurrency(cell.currency) }),
        'Data de Pagamento'
      ),
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
        width: '11%',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
    },
    {
      dataField: 'analyst',
      text: [t('label:analyst'), <i className="fas fa-sort float-right" />],
      sort: true,
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      formatter: (cell) => renderValue(cell,t('label:analyst'))
    },
    {
      dataField: 'actions',
      text: 'Ações',
      sort: 'disabled',
      headerStyle: {
        width: '5%',
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      formatter: (cell) => renderActionBtn(cell)
    },
  ];
  
  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.isCreativeEditable) {
      style.backgroundColor = 'rgb(255 226 226)';
    }

    if (row.hasComprovations) {
      style.backgroundColor = 'rgb(255 226 226)';
    }
    return style;
  };

  const getTotal = (id) => {
    const result = totalFunds(id)
    return result.value
      .toLocaleString('pt-BR', { 
        style: 'currency', 
        currency: getCurrency(result.currency) 
      });
  }

  const getDataToExport = async (isCourtesy = false, onlyFiltered = true) => {
    setIsExporting(true)
    let _filters = { 
      ...stateFilters, 
      __is_courtesy: isCourtesy ? 1 : 0
    }

    if (!onlyFiltered) {
      delete _filters.per_page
      delete _filters.page
    }

    return await api.get('actions', { params: { ..._filters } });
  }

  const doExport = (_data, isCourtesy = false) => {
    let a = document.createElement('a');
    let table_div = createTableToExport(columns, _data);
    var blobData = new Blob(['\ufeff'+ReactDOMServer.renderToString(table_div)], {
      type: 'application/vnd.ms-excel'
    }) 
    a.href = window.URL.createObjectURL(blobData)
    a.download = isCourtesy ? 'list_actions_courtesy' : 'list_actions_filtered';
    a.click();
    setIsExporting(false)
  }

  const createTableToExport = (cols, { data }) => {
    return (
      <table>
        <thead>
          <tr>
            {cols.map((col, i) => {
              if (col.dataField != 'actions') {
                return (            
                  <th key={i}>{col.text instanceof Array ? col.text[0] : col.text }</th>
                )
              }            
            })}
          </tr>
        </thead>
        <tbody>
          {data.map(item => (
            <tr key={item.id}>
              <td>{t(`statuses:${statusName(item.status_action)}`)}</td>
              <td>{item.id}</td>
              <td>{item.marketing_plan_id ?? "--"}</td>
              <td>{item.name}</td>
              <td>{item.company_alias}</td>
              <td>{item.task_name}</td>
              <td>{parseDateBR(item.start_date)}</td>
              <td>{parseDateBR(item.end_date)}</td>
              <td>{item.payment_date ?? "--"}</td>
              <td>{item.vendor_id ?? "--"}</td>
              <td>{getTotal(item.id)}</td>
              <td>{item.user_name ?? "--"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  };

  return (
    <>
      <Row>
        <Col>
          <Row className="justify-content-end">
            {filters.map((filter, k) => {
              return filter.name !== 'company' ? (
                <Col key={k} md={2}>
                  <Form.Group>
                    <Form.Label>{t(`label:${filter.name}`)}</Form.Label>
                    <Form.Control
                      value={stateFilters[filter.key]}
                      onChange={(e) =>
                        handleFilterChange({
                          [filter.key]: e.target.value,
                          page: 1,
                        })
                      }
                      as="select"
                    >
                      <option value="">{t('label:all')}</option>
                      {filter.options.map((option, k) => (
                        <option key={k} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              ) : (
                <Col key={k} md={2}>
                  <Form.Group>
                    <Form.Label>{t('label:company')}</Form.Label>
                    <Select
                      defaultValue={{ label: 'Todos', value: '' }}
                      selectedValue={stateFilters[filter.key]}
                      name="vendor"
                      options={[
                        ...[{ label: 'Todos', value: '' }],
                        ...filter.options,
                      ]}
                      onClick={stateFilters[filter.key]}
                      placeholder={t('label:select')}
                      onChange={(e) =>
                        handleFilterChange({ [filter.key]: e.value, page: 1 })
                      }
                      noOptionsMessage={() =>
                        filter.options.length == 0
                          ? t('label:loading')
                          : 'No Options'
                      }
                    />
                  </Form.Group>
                </Col>
              );
            })}
            <Col md={3}>
              <Form.Group>
                <Form.Label>{t('label:records per page')}:</Form.Label>
                <Form.Control
                  as="select"
                  value={stateFilters.per_page}
                  onChange={(e) =>
                    handleFilterChange({ per_page: e.target.value, page:1 })
                  }
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:search')}:</Form.Label>
                <DebounceInput
                  element={Form.Control}
                  debounceTimeout={500}
                  value={stateFilters.__search}
                  onChange={(e) =>
                    handleFilterChange({ __search: e.target.value, page:1 })
                  }
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="2">
              <Form.Group>
                <Form.Label>Data Inicial: (Data Final)</Form.Label>
                <DatePicker
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  locale="pt_BR"
                  isClearable
                  selected={startDate}
                  onChange={(date) => {
                    changeDateFilter(date, '__start_date')
                    setStartDate(date)
                  }}
                  placeholderText={t('label:insert here')}
                  shouldCloseOnSelect={false}
                  required
                />
              </Form.Group>
            </Col>
            <Col md="2">
              <Form.Group>
                <Form.Label>Data Final: (Data Final)</Form.Label>
                <DatePicker
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  locale="pt_BR"
                  isClearable
                  selected={endDate}
                  onChange={(date) => {
                    changeDateFilter(date, '__end_date')
                    setEndDate(date)
                  }}
                  placeholderText={t('label:insert here')}
                  shouldCloseOnSelect={false}
                  required
                  minDate={startDate ?? new Date() }
                  disabled={!startDate}
                />
              </Form.Group>
            </Col>
            <Col>
              {isExporting ? (
                <Button className="mt-4 d-flex align-items-center justify-content-center" disabled={true}>
                  <span className='mr-2'>Exportar</span>
                  <Spinner 
                    animation="border"
                    size="sm"
                    style={{ color: '#ffffff' }} 
                  />
                </Button>
              ) : (
                <DropdownButton className="mt-4" id="dropdown-basic-button" title="Exportar">
                  <Dropdown.Item onClick={async () => {
                    const response = await getDataToExport(true)
                    const { data } = response
                    doExport(data)
                  }}>Geral</Dropdown.Item>
                  <Dropdown.Item onClick={async () => {
                    const response = await getDataToExport(true, false)
                    const { data } = response
                    doExport(data, true)
                  }}>Apenas Cortesia</Dropdown.Item>
                </DropdownButton>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <BootstrapTable
                responsive
                keyField="id"
                data={actionsData}
                columns={columns}
                wrapperClasses="table-responsive table-mobile-transform"
                rowStyle={ rowStyle }
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Trans i18nKey="label:interpolateShowingRecords">
                Showing {{ from: data.pagination.from || '0' }} to {{ to: data.pagination.to || '0' }}{' '}
                from {{ total: data.pagination.total }} records
              </Trans>
            </Col>
            <Col className="d-flex justify-content-end">
              <Pagination
                activePage={data.pagination.current_page}
                itemsCountPerPage={data.pagination.per_page}
                totalItemsCount={data.pagination.total}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
                prevPageText="‹"
                nextPageText="›"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default withRouter(ListingActions);